import { SavedTripList } from '../../models/core-apis/saved-search.interfaces';

export const prepareSearchModalSavedSearchList = (
  savedSearchDataList: SavedTripList[] | undefined
): string[] => {
  const savedSearchList: string[] = [];

  if (savedSearchDataList?.length) {
    savedSearchDataList.forEach((savedSearch) => {
      savedSearchList.push(savedSearch.alias);
    });
  }

  return savedSearchList;
};
